import { Injectable } from '@angular/core';
import { Api, User } from '@providers/index'

@Injectable()
export class Task {
  list: any;

  constructor(public api:Api, public user:User) { 

  }

  get(params?: any) {
    return this.api.get('index.php/project/task', params);
  }


  post(params?: any) {
    if(params.id==''){
      params.created_by = this.user.data.employee_id;
    }else{
      params.updated_by = this.user.data.employee_id;
    }
    return this.api.post('index.php/project/task', params);
  }

  getTaskImages(params?: any) {
    return this.api.get('index.php/project/task/taskImages', params);
  }


}


// WEBPACK FOOTER //
// ./src/providers/project_providers/task/task.ts